export default __webpack_public_path__ + "static/media/techsahead.a398670e.png";